// src/pages/Contact.tsx
//
// The /contacts route, kept for direct links and bookmarks.
//
// The connect form itself is not here. It lives in
// components/Contact/ContactForm and is rendered identically inside
// ContactModal, so there is exactly one implementation of the validation and the
// email call. This page is only the frame around it, for the case where someone
// arrives on /contacts directly rather than opening the window from somewhere in
// the site.
//
// The page previously redirected to "/" once the success message ran out, which
// threw away the visitor's place. That is now the caller's decision, and this
// caller does not ask for it.
//
// If this route is ever retired, delete this file and its <Route> in App.tsx —
// the Navbar and the Footer open the window directly and would keep working.
import styled from 'styled-components';

import Footer from '../components/Footer';
import ContactForm from '../components/Contact/ContactForm';

const Page = styled.main`
  width: 90%;
  max-width: 640px;
  margin: 3rem auto 0;
  padding: 2rem 1.5rem;
  background: ${({ theme }) => theme.surface};
  border: ${({ theme }) => theme.cardBorder};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  box-shadow: ${({ theme }) => theme.shadows.lg};

  @media (max-width: 480px) {
    margin-top: 1.5rem;
    padding: 1.25rem 1rem;
  }
`;

/**
 * The heading lives here rather than inside ContactForm, because the modal
 * already has a title bar saying the same thing. On this page there is no window,
 * so the page has to supply it.
 */
const Title = styled.h1`
  margin: 0 0 0.5rem;
  font-size: 1.75rem;
  font-weight: 700;
  color: ${({ theme }) => theme.headingColor};

  @media (max-width: 480px) {
    font-size: 1.4rem;
  }
`;

const Contact = () => (
  <>
    <Page>
      <Title>Let&apos;s Connect</Title>
      {/* No onSuccess. The window closes itself; the page stays put. */}
      <ContactForm />
    </Page>
    <Footer />
  </>
);

export default Contact;
